import 'babel-polyfill'
import App from './app'
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import fastclick from 'fastclick'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
// bootstrap
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
// AdminLTE
import 'assets/css/skins/_all-skins.min.css'
import 'assets/css/AdminLTE.min.css'
import 'assets/js/adminlte.js'

import routes from './router'
import store from './store'
import {delCookie} from 'common/js/cookie-util'
import {baseUrl} from 'api/base'
import {fromClub} from 'common/js/app-utils'

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.config.productionTip = false

fastclick.attach(document.body)

// Http
Vue.http.options.root = baseUrl

Vue.http.interceptors.push(function (request, next) {
  next(function (res) {
    if (res.status === 401) {
      localStorage.clear()
      delCookie('rememberMe')
      location.href = '/#/login'
    }
  })
})

// Router
const router = new VueRouter({
  linkActiveClass: 'active',
  routes
})
Vue.router = router

// Auth
Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'roles'
})

window.Vue = Vue

/* eslint-disable no-new */
new Vue({
  router: Vue.router,
  store,
  render: h => h(App)
}).$mount('#app')

window.onload = () => {
  sessionStorage.clear()
  // 隐藏谷歌翻译的操作面板
  // document.querySelector('.goog-te-banner-frame').style.display = 'none'
}

// global funciton fromClub
Vue.prototype.fromClub = fromClub



// WEBPACK FOOTER //
// ./src/main.js